import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { useForm } from 'react-hook-form';

import GlobalContext from '../../../../context/GlobalContext';

import { ButtonStyled } from '../login/login.styles';

import ToasterBox from '../../../components/singleComponents/toaster/ToasterBox';

import {
  Container,
  Input2Styled,
  SubtitleStyled,
  ContainerStyled,
  LogoContainerStyled,
  LogoStyled,
} from './ResendEmail.style';

import Logo from '../../../../assets/logo.png';

import api, { authHeader } from '../../../../services/API/apiConfig';

export default function AccountRetrieve() {
  const navigate = useNavigate();

  const { companyData } = useContext(GlobalContext);

  const baseURL = process.env.REACT_APP_API;
  const protocol = companyData.subdomain.endsWith('-st') ? 'http' : 'https';

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [toaster, setToaster] = useState({
    show: false,
    message: '',
  });

  const checkStatus = (status) => {
    const message =
      status === 1
        ? 'Sua conta já foi verificada. Redirecionando para a área de login.'
        : 'Email enviado com sucesso.';
    setToaster({ show: true, message });

    setTimeout(() => {
      setToaster({ show: false, message: '' });
      if (status === 1) navigate('/login');
    }, 3000);
  };

  const resendEmail = async (formData) => {
    try {
      const userInfo = {
        email: formData.email,
        subdomain: companyData.subdomain,
      };
      const {
        data: { status },
      } = await api.post('/users/resend-verification', userInfo, {
        headers: authHeader(),
      });
      checkStatus(status);
    } catch (err) {
      setToaster({
        show: true,
        message:
          'Algo deu errado. Verifique se o email informado está correto.',
      });
      setTimeout(() => {
        setToaster({ show: false, message: '' });
      }, 3000);
    }
  };

  const path = companyData?.logo?.url
    ? `${protocol}://${companyData.subdomain}.${baseURL}${companyData.logo.url}`
    : Logo;

  return (
    <ContainerStyled>
      <LogoContainerStyled>
        <LogoStyled path={path} />
      </LogoContainerStyled>
      <Container>
        {toaster.show && <ToasterBox message={toaster.message} />}
        <SubtitleStyled variant="h3">
          Para receber um novo link de ativação, digite seu e-mail.
        </SubtitleStyled>
        <Input2Styled
          fullWidth
          placeholder="E-mail"
          {...register('email', { required: 'Campo obrigatório' })}
          error={!!errors.email}
          helperText={errors.email && errors.email.message}
        />
        <ButtonStyled fullWidth onClick={handleSubmit(resendEmail)}>
          Reenviar
        </ButtonStyled>
      </Container>
    </ContainerStyled>
  );
}
